import {
  IWorkFlowActivityItem,
  IWorkFlowStatus
} from '@shared/services/service-mappers/WorkflowMapper';
import {TICKETING_SYSTEM_TICKET_ACTION_TYPES} from '@shared/constants/Mapping';

export const getWorkflowStatusLabel = (
  statuses: IWorkFlowStatus[],
  statusId: IWorkFlowStatus['id']
): string | undefined => {
  const status = statuses.find(s => s.id === statusId);
  if (status) {
    return status.label;
  }
};
export const isWorkflowEndStatus = (
  statuses: IWorkFlowStatus[],
  statusId: IWorkFlowStatus['id']
): boolean => {
  const status = statuses.find(s => s.id === statusId);
  if (status) {
    return status.is_end_status;
  }
  return false;
};

export const formatUpdatedKeyLabel = (key: string): string => {
  if (key === 'description') {
    return 'notes';
  }
  return key.split('_').join(' ');
};

export const formatTicketActivityItem = (
  item: IWorkFlowActivityItem
): IWorkFlowActivityItem[] => {
  if (
    item?.type === TICKETING_SYSTEM_TICKET_ACTION_TYPES.UPDATE_TICKET &&
    item.metadata &&
    Object.keys(item.metadata).length
  ) {
    const commonItemData = {...item};
    delete commonItemData.metadata;
    const metaKeys = Object.keys(item.metadata);
    return metaKeys.map(metaKey => {
      return {
        ...commonItemData,
        metadata: {
          [metaKey]: item.metadata?.[metaKey] as any
        }
      };
    });
  }
  return [item];
};
export const getFilteredNextSteps = (
  currentStatus: IWorkFlowStatus,
  clinicTicketConfig: any,
  module: any
): IWorkFlowStatus[] => {
  let filteredNextSteps = currentStatus.nextSteps || [];
  if (currentStatus.code === 'denied' && module === 'tms-prior-auth') {
    if (clinicTicketConfig?.personal_injury_practice === 'true') {
      filteredNextSteps = filteredNextSteps.filter(
        step => step.code !== 'appeal-reconsideration'
      );
    } else {
      filteredNextSteps = filteredNextSteps.filter(
        step => step.code !== 'pre_service_appeal_sent_after_denied'
      );
    }
  }
  return filteredNextSteps;
};
